import { analyticsPageNames as pageNames } from '../../../constants/analyticsConstants';

const routes = [
  {
    regex: /^\/$/,
    pageName: pageNames.ACCOUNT,
  },
  {
    regex: /^\/account-overview$/,
    pageName: pageNames.ACCOUNT,
  },
  {
    regex: /^\/home$/,
    pageName: pageNames.ACCOUNT,
  },
  {
    regex: /^\/my-details$/,
    pageName: pageNames.ACCOUNT_DETAILS,
  },
  {
    regex: /^\/my-details\/address-book$/,
    pageName: pageNames.ADDRESS_BOOK,
  },
  {
    regex: /^\/my-details\/address-book\/add$/,
    pageName: pageNames.ADDRESS_BOOK_ADD,
  },
  {
    regex: /^\/my-details\/contact$/,
    pageName: pageNames.CONTACT_DETAILS,
  },
  {
    regex: /^\/my-details\/edit-password$/,
    pageName: pageNames.EDIT_PASSWORD,
  },
  {
    regex: /^\/my-details\/payment-cards$/,
    pageName: pageNames.PAYMENT_DETAILS,
  },
  {
    regex: /^\/my-jl\/register$/,
    pageName: pageNames.MY_JL_JOIN,
  },
  {
    regex: /^\/my-jl\/details$/,
    pageName: pageNames.MY_JL_DETAILS,
  },
  {
    regex: /^\/wish-list$/,
    pageName: pageNames.WISH_LIST,
  },
  {
    regex: /^\/wish-list\/.+$/,
    pageName: pageNames.WISH_LIST_LIST,
  },
  {
    regex: /^\/marketing-preferences$/,
    pageName: pageNames.MARKETING_PREFERENCES,
  },
  {
    regex: /^\/marketing-preferences\/update$/,
    pageName: pageNames.MARKETING_PREFERENCES_UPDATE,
  },
  {
    regex: /^\/need-help$/,
    pageName: pageNames.CONTACT_AND_HELP,
  },
  {
    regex: /^\/login$/,
    pageName: pageNames.SIGN_IN,
  },
  {
    regex: /^\/repermission$/,
    pageName: pageNames.MARKETING_CONSENT,
  },
  {
    regex: /^\/register$/,
    pageName: pageNames.REGISTER,
    breadCrumb: [
      {
        clickable: 1,
        value: 'account',
      },
      {
        clickable: 1,
        value: 'sign in',
      },
      {
        clickable: 0,
        value: 'register',
      },
    ],
  },
  {
    regex: /^\/account-created/,
    pageName: pageNames.REGISTER_COMPLETE,
  },
  {
    regex: /^\/account-created-my-jl$/,
    pageName: pageNames.REGISTER_COMPLETE_JOIN_COMPLETE,
  },
  {
    regex: /^\/orders\/\d+\/track$/,
    pageName: pageNames.TRACK_ORDER,
  },
  {
    regex: /^\/track-order$/,
    pageName: pageNames.TRACK_ORDER_FORM,
  },
  {
    regex: /^\/orders\/\d+$/,
    pageName: pageNames.VIEW_ORDER,
  },
  {
    regex: /^\/orders\/\d+\/receipts\/\d+$/,
    pageName: pageNames.VAT_RECEIPT,
  },
  {
    regex: /^\/orders\/\d+\/cancel-items\/select$/,
    pageName: pageNames.CANCEL_ITEMS,
  },
  {
    regex: /^\/orders\/\d+\/cancel-items\/review$/,
    pageName: pageNames.CANCEL_ITEMS_REVIEW,
  },
  {
    regex: /^\/orders\/\d+\/cancel-items\/confirmation$/,
    pageName: pageNames.CANCEL_ITEMS_CONFIRMED,
  },
  {
    regex: /^\/orders\/\d+\/return-items\/method$/,
    pageName: pageNames.RETURN_ITEMS_METHOD,
  },
  {
    regex: /^\/orders\/\d+\/return-items\/information$/,
    pageName: pageNames.RETURN_ITEMS_INFORMATION,
  },
  {
    regex: /^\/orders\/\d+\/return-items\/select$/,
    pageName: pageNames.RETURN_ITEMS_SELECT,
  },
  {
    regex: /^\/orders\/\d+\/return-items\/summary$/,
    pageName: pageNames.RETURN_ITEMS_SUMMARY,
  },
  {
    regex: /^\/orders\/\d+\/return-items\/confirmation$/,
    pageName: pageNames.RETURN_ITEMS_CONFIRMED,
  },
  {
    regex: /^\/orders\/\d+\/return-items\/unsupported-reason$/,
    pageName: pageNames.RETURN_ITEMS_CONTACT,
  },
  {
    regex: /^\/orders$/,
    pageName: pageNames.ORDERS,
  },
  {
    regex: /^\/store-receipts$/,
    pageName: pageNames.IN_STORE_RECEIPTS,
  },
  {
    regex: /^\/store-receipts\/transaction\/\d+$/,
    pageName: pageNames.IN_STORE_VIEW_RECEIPT,
  },
  {
    regex: /^\/rewards$/,
    pageName: pageNames.REWARDS_AND_TREATS,
  },
  {
    regex: /^.*:[4-5][0-9]{2} error page$/,
    pageType: 'errorpage',
  },
];

export function getPageInfo(pathname) {
  const route = routes.find(r => r.regex.test(pathname));
  const newPageName = route ? route.pageName || pathname : pathname;
  const newPageType = route ? route.pageType || 'account' : 'account';

  let breadCrumb = route && route.breadCrumb;
  if (!breadCrumb) {
    const paths = newPageName.split(':');
    breadCrumb = paths.map(value => ({
      value,
      clickable: 1,
    }));
  }

  return {
    breadCrumb,
    pageName: `jl:${newPageName}`,
    pageType: newPageType,
    site: window.location.host,
  };
}

export default function analyticsFactory(pathname, data = {}, pageInfo = {}) {
  const analytics = {};
  const { error, customer, ...pageData } = data;

  if (customer) {
    analytics.customer = customer;
  }

  analytics.page = {
    locale: {
      country: 'uk',
      currency: 'gbp',
      language: 'en-gb',
    },
    pageInfo: { ...getPageInfo(pathname), ...pageInfo },
    ...pageData,
  };

  if (error) {
    analytics.error = error;
  }
  return analytics;
}
